import { gql } from "@apollo/client";

const GET_COUNTRIES = gql`
  query GetProfile {
    placesLivingIn {
      name
    }
  }
`;

export default GET_COUNTRIES;
